import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import BottomTabBar from "./BottomTabBar";
import {
  FiHome,
  FiCreditCard,
  FiList,
  FiFileText,
  FiSettings,
  FiLogOut,
  FiPackage,
  FiTool,
  FiPieChart,
  FiDollarSign,
  FiUsers,
} from "react-icons/fi";

function Layout() {
  const { user, logout } = useAuth();
  const isAdmin =
    user?.roles?.includes("admin") ||
    user?.roles?.includes("super_admin") ||
    user?.roles?.includes("payments.admin") ||
    user?.permissions?.includes("payments.dashboard.admin") ||
    user?.permissions?.includes("payments.admin");

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h1>
            <FiCreditCard />
            Payments
          </h1>
        </div>

        <nav className="sidebar-nav">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FiHome />
            Dashboard
          </NavLink>

          <NavLink
            to="/subscriptions"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FiPackage />
            Subscriptions
          </NavLink>

          <NavLink
            to="/transactions"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FiList />
            Transactions
          </NavLink>

          <NavLink
            to="/invoices"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FiFileText />
            Invoices
          </NavLink>

          <NavLink
            to="/settings"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FiSettings />
            Settings
          </NavLink>

          {isAdmin && (
            <div className="nav-section">
              <div className="nav-section-title">Administration</div>

              <NavLink
                to="/admin"
                end
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiPieChart />
                Overview
              </NavLink>

              <NavLink
                to="/admin/pricing"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiDollarSign />
                Subscriptions
              </NavLink>

              <NavLink
                to="/admin/users"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers />
                Users
              </NavLink>

              <NavLink
                to="/admin/integrations"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiTool />
                Integrations
              </NavLink>
            </div>
          )}

          <div className="nav-section">
            <button
              className="nav-item"
              onClick={logout}
              style={{
                width: "100%",
                border: "none",
                background: "none",
                textAlign: "left",
              }}
            >
              <FiLogOut />
              Logout
            </button>
          </div>
        </nav>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>

      <BottomTabBar isAdmin={isAdmin} />
    </div>
  );
}

export default Layout;
